import { render, staticRenderFns } from "./TeamLeaderView.vue?vue&type=template&id=4890ada7&scoped=true"
import script from "./TeamLeaderView.vue?vue&type=script&lang=js"
export * from "./TeamLeaderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890ada7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4890ada7')) {
      api.createRecord('4890ada7', component.options)
    } else {
      api.reload('4890ada7', component.options)
    }
    module.hot.accept("./TeamLeaderView.vue?vue&type=template&id=4890ada7&scoped=true", function () {
      api.rerender('4890ada7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/views/TeamLeaderView.vue"
export default component.exports